<template>
  <el-container v-title data-title="职员分组列表" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>学校管理</el-breadcrumb-item>
                <el-breadcrumb-item>职员分组</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="组名">
                  <el-input v-model="searchForm.name" placeholder="组名"></el-input>
                </el-form-item>
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="每页条数">
                  <el-select v-model="pageSize" @change="handleSizeChange" style="width:80px">
                    <el-option v-for="(item, index) in pageSizes" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getStaffGroupList">查询</el-button>
                  <el-button type="primary" @click="openAddDialog">新增</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="name" label="组名"></el-table-column>
          <el-table-column prop="schoolName" label="学校"></el-table-column>
          <el-table-column label="职员姓名">
            <template slot-scope="scope">
              <span v-for="(realName, index) in scope.row.staffRealNameList" :key="index">{{realName}} </span>
            </template>
          </el-table-column>
          <el-table-column prop="statusName" label="状态"></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" @click="openModifyDialog(scope.row)">修改</el-button>
              <el-button type="text" @click="changeStatus(scope.row)">{{ scope.row.status == '1' ? '停用' : '启用' }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="getStaffGroupList"
            :current-page.sync="currentPage"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :total="total"
            layout="total,sizes,prev,pager,next" >
          </el-pagination>
        </div>
      </el-main>
      <!-- 弹窗页（修改） -->
      <el-dialog
        title="修改"
        :visible.sync="modifyDialogVisible"
        width="98%"
        :before-close="handleClose">
        <el-form ref="modifyForm" :model="modifyData" :rules="rules" label-width="90px">
          <el-form-item label="组名" :required="true" prop="name">
            <el-input v-model="modifyData.name" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="学校">
            <el-select v-model="modifyData.schoolId" @change="toggleSchool(modifyData)">
              <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="职员">
            <el-checkbox-group v-model="modifyData.checkedStaffList">
              <el-checkbox-button v-for="staff in modifyData.staffListForSelect" :label="staff" :key="staff.id">{{staff.realName}}</el-checkbox-button>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="modifyStaffGroup">修改</el-button>
            <el-button @click="modifyDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 弹窗页（新增） -->
      <el-dialog
        title="新增"
        :visible.sync="addDialogVisible"
        width="98%"
        :before-close="handleClose">
        <el-form ref="addForm" :model="addData" :rules="rules" label-width="90px">
          <el-form-item label="组名" :required="true" prop="name">
            <el-input v-model="addData.name" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="学校">
            <el-select v-model="addData.schoolId" @change="toggleSchool(addData)">
              <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="职员">
            <el-checkbox-group v-model="addData.checkedStaffList">
              <el-checkbox-button v-for="staff in addData.staffListForSelect" :label="staff" :key="staff.id">{{staff.realName}}</el-checkbox-button>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addStaffGroup">新增</el-button>
            <el-button @click="addDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 15,
      pageSizes: [15, 50, 100, 150, 200, 300, 500, 1000, 2000],
      total: 0,
      searchForm: {},
      staffList: [],
      modifyData: {
        id: null,
        name: null,
        schoolId: null,
        schoolIdOld: null,
        staffListForSelect: [],
        checkedStaffList: [],
        userIdlist: []
      },
      modifyDialogVisible: false,
      addData: {
        schoolId: null,
        staffListForSelect: [],
        checkedStaffList: [],
        userIdlist: []
      },
      addDialogVisible: false,
      schoolList: [],
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
      }
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getStaffGroupList()
      this.getStaffList()
      this.getSchoolList()
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      done()
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.getStaffGroupList()
    },
    openModifyDialog (staffGroupData) {
      this.modifyData.id = staffGroupData.id
      this.modifyData.name = staffGroupData.name
      this.modifyData.schoolId = this.modifyData.schoolIdOld = staffGroupData.schoolId
      this.modifyData.userIdList = staffGroupData.userIdList
      this.toggleSchool(this.modifyData)
      this.modifyDialogVisible = true
    },
    modifyStaffGroup () {
      let _this = this
      _this.modifyData.userIdList = _this.modifyData.checkedStaffList.map(item => item.id)
      this.$refs['modifyForm'].validate((valid) => {
        if (valid) {
          this.$axios.post(this.GLOBAL.host + '/staff/group/update',
            _this.modifyData
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.modifyDialogVisible = false
                _this.modifyData.id = null
                _this.modifyData.name = null
                _this.modifyData.schoolId = null
                _this.modifyData.userIdList = []
                _this.modifyData.staffListForSelect = []
                _this.modifyData.checkedStaffList = []
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
                _this.getStaffGroupList()
              } else {
                this.$message.error(res.data.message)
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
      this.$refs['modifyForm'].resetFields()
    },
    openAddDialog () {
      this.addData.schoolId = this.schoolList[0].id
      this.addData.staffListForSelect = []
      this.addData.checkedStaffList = []
      this.toggleSchool(this.addData)
      this.addDialogVisible = true
    },
    addStaffGroup () {
      let _this = this
      _this.addData.userIdList = _this.addData.checkedStaffList.map(item => item.id)
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          this.$axios.post(this.GLOBAL.host + '/staff/group/add',
            _this.addData
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.addDialogVisible = false
                _this.addData.schoolId = null
                _this.addData.staffListForSelect = []
                _this.addData.checkedStaffList = []
                this.$message({
                  message: '新增成功',
                  type: 'success'
                })
                _this.getStaffGroupList()
                _this.$refs['addForm'].resetFields()
              } else {
                this.$message.error(res.data.message)
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getStaffGroupList () {
      let _this = this
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/staff/group/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id,
          name: _this.searchForm.name,
          schoolId: _this.searchForm.schoolId,
          page: _this.currentPage,
          size: _this.pageSize
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.total = res.data.data.total
            _this.tableData = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
      _this.loading = false
    },
    getStaffList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/user/listStaff',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.staffList = res.data.data
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    toggleSchool (formData) {
      formData.staffListForSelect = []
      formData.checkedStaffList = []
      if (formData.schoolId !== undefined) {
        this.staffList.forEach(staff => {
          if (staff.schoolId === formData.schoolId) {
            formData.staffListForSelect.push(staff)
          }
        })
      }
      if (formData.schoolId === formData.schoolIdOld && formData.userIdList !== undefined && formData.userIdList !== null) {
        formData.userIdList.forEach(userId => {
          this.staffList.forEach(staff => {
            if (staff.id === userId) {
              formData.checkedStaffList.push(staff)
            }
          })
        })
      }
    },
    changeStatus (staffGroupData) {
      if (staffGroupData === null) return
      let _this = this
      this.$confirm('确认要' + (staffGroupData.status === '1' ? '停用' : '启用') + '吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.GLOBAL.host + '/staff/group/changeStatus',
          this.$qs.stringify({ id: staffGroupData.id, status: staffGroupData.status === '1' ? '0' : '1' })
        ).then(res => {
          if (res.data != null) {
            if (res.data.status === 200) {
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
            }
            _this.getStaffGroupList()
          }
        })
      })
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/StaffGroup.vue